import { render, staticRenderFns } from "./add-exams.vue?vue&type=template&id=b7a169de&scoped=true&"
import script from "./add-exams.vue?vue&type=script&lang=js&"
export * from "./add-exams.vue?vue&type=script&lang=js&"
import style0 from "./add-exams.vue?vue&type=style&index=0&id=b7a169de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a169de",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
